import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// config
import { defaultLang } from '../config';
//
import enLocales from './en';
import esLocales from './es';


// ----------------------------------------------------------------------

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      es: { translations: esLocales },

    },
    // The language comes from the URL (/es/..., /en/...). Without a prefix it
    // falls back to Spanish. Nothing is cached here: LanguageAwareApp stores
    // the language of the page being viewed.
    detection: { order: ['path'], lookupFromPathIndex: 0, caches: [] },
    fallbackLng: defaultLang.value,
    supportedLngs: ['es', 'en'],
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
